import React from 'react';
import dynamic from 'next/dynamic';
import classnames from 'classnames/bind';
import styles from '../introduce.module.scss';

const ReactPlayer = dynamic(() => import('react-player') as any, { ssr: false }) as any;

const cx = classnames.bind(styles);

const Jobda = () => {
  return (
    <div className={cx('contents')}>
      <div className={cx('titleWrap')}>
        <span className={cx('title', 'GREEN')}>
          잡다도
          <br />
          알고 있습니다
        </span>
      </div>
      <div className={cx('jobdaContentsWrap')}>
        <div className={cx('videoWrap')}>
          <ReactPlayer
            url={'/video/acc/introduce/videoBrain.mp4'}
            playing={true}
            muted={true}
            loop={true}
            width={'100%'}
            height={'100%'}
          />
        </div>
        <img src={'/img/acc/introduce/imgJobda01.png'} alt={''} />
      </div>
      <div className={cx('textWrap')}>
        <div className={cx('descTitleWrap')}>
          <span className={cx('descTitle')}>
            잡다가 정의하는 역량,
            <br />
            성과를 낼 수 있는 힘입니다.
          </span>
        </div>
        <div className={cx('descWrap')}>
          <span className={cx('desc')}>
            그렇다면 성과는 어떻게 만들어질까요? 신경과학 연구결과에 의하면 우리 뇌의 많은 영역 중에서 성과중추라고
            불리는 전전두엽에서 성과를 만듭니다.
          </span>
          <span className={cx('desc')}>
            <em className={cx('bold')}>
              신뢰 확인-열정 발현-전략 모색-실행 지속의 과정을 거치는 메커니즘을 통해 우리 뇌는 성과를 만듭니다.
            </em>{' '}
            그래서 성과를 만들어 내는 역량은 신뢰를 확인할 수 있는
            <em className={cx('bold')}> 긍정성</em>, 열정을 발현시킬 수 있는
            <em className={cx('bold')}> 적극성</em>, 전략을 모색하게 하는
            <em className={cx('bold')}> 전략성</em>, 그리고 실행을 지속할 수 있는
            <em className={cx('bold')}> 성실성</em>입니다.
          </span>
          <span className={cx('desc')}>
            우리는 이 긍정성, 적극성, 전략성, 성실성을 성과 역량이라고 정의합니다. 또한 대인과 상호작용을 잘 하는
            <em className={cx('bold')}> 관계성</em>, 자신을 돌아볼 수 있는 자기인식과 같은
            <em className={cx('bold')}> 정체성</em> 그리고 인지하고 있다는 것을 인지하는
            <em className={cx('bold')}>
              {' '}
              메타인지와 같은 객관성 모두 7가지 역량을 잡다에서는 핵심 역량이라고 정의합니다.
            </em>
          </span>
        </div>
      </div>
    </div>
  );
};

export default Jobda;
